import React, { Component } from "react";
import Auth from "j-toker";
import LocalizedStrings from "react-localization";
import en from "../localization/localization-en.json";
import { renderErrorMessage } from "../helper/user_helper";
import { getUser } from "../helper/user_helper";

let strings = new LocalizedStrings({ en });

class ForgetPassword extends Component {
  state = { email: "", password: "", errors: "", message: "" };

  componentDidMount() {
    // Check if user is already login
    // const self = this;
    // this.userCall = getUser();
    // this.userCall.promise.then(answer => {
    //   if (answer.signedIn === true) {
    //     self.props.history.push("/profile");
    //     return;
    //   }
    // });
  }

  render() {
    return (
      <div className="center max_width_300">
        <form onSubmit={this.handleForgetPasswordClick}>
          <label className="yaystack_input_text_label pt-5">
            <input
              className="yaystack_input_text mb-3"
              type="email"
              required={true}
              value={this.state.email}
              placeholder={strings.email}
              onChange={this.handleChangeEmail}
            />
          </label>
          <br />
          <input
            type="submit"
            value={strings.reset_password}
            className="btn btn_primary btn_yaystack mb-3 width_100"
          />
        </form>
        {renderErrorMessage(this.state.errors)}
        {this.renderMessage()}
      </div>
    );
  }

  renderMessage() {
    if (this.state.message != "") {
      return (
        <div className="center">
          <label className="alert alert-success block mb-3 mt-3">
            {this.state.message}
          </label>
        </div>
      );
    }
  }

  handleChangeEmail = event => {
    this.setState({ email: event.target.value });
  };

  handleForgetPasswordClick = event => {
    event.preventDefault();
    let errors = "";
    let message = "";
    this.setState({ errors, message });
    Auth.requestPasswordReset({
      email: this.state.email
    })
      .then(
        function(user) {
          let message = user.message;
          this.setState({ message });
          console.log(user);
        }.bind(this)
      )

      .fail(
        function(res) {
          let errors = res.data.errors.join(", ");
          this.setState({ errors });
        }.bind(this)
      );
  };
}

export default ForgetPassword;



// WEBPACK FOOTER //
// ./src/pages/forget_password.jsx